/**
 * The two icons that survive #171.
 *
 * The screens used to put an icon on everything to say what kind of thing it
 * was: a tick for a status, a flag for a priority, a building for a location.
 * The customer found that the colours say that well enough and wanted the room
 * for text, so those went. Two stayed, because they say something about the
 * value rather than its kind: that the ticket is done, and that it is urgent.
 */

/**
 * The done status, by name. The backend recognises it the same way
 * (ArchiveTicketThatIsDone), and the ids differ from one database to another.
 */
export const DONE_STATUS_NAME = "Klaar";

/**
 * The importance the backend gives the high priority. Importance, not the id or
 * the word: those differ per database and can be renamed.
 */
export const HIGH_PRIORITY_IMPORTANCE = 5;

/**
 * The icon a value still carries, or null for the rest.
 *
 * @param topic the kind of value, as the choosers name it
 * @param label the value's own name, which is what decides for a status
 * @param importance the value's importance, which is what decides for a priority
 */
export function badgeFor(
    topic: string,
    label: string | null | undefined,
    importance: number | null | undefined
): string | null {
    if (topic === "status") {
        return (label ?? "").trim() === DONE_STATUS_NAME ? "check_circle" : null;
    }
    if (topic === "priority") {
        return (importance ?? 0) >= HIGH_PRIORITY_IMPORTANCE ? "flag" : null;
    }
    return null;
}
